import { faCartShopping, faSignIn, faSignOut } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import { Navbar, Nav, Container, Button, Row, Col, Badge, Stack } from "react-bootstrap";
import TimerBox from "./timerBox";
import signalDispatcher from "../utils/signalDispatcher";
import Cart from "../models/cart-model";
import CommonService from "../services/common.service";

interface HeaderProps {
    dictionary?: Record<string, any>;
}

interface HeaderState {
    pageTitle: string;
    pageSlogen1: string;
    pageSlogen2: string;
    pageCartCounter: number;
    pageTimer: number;
    pageMenuItems: Array<{ label: string, link: string }>;
    dictionary?: Record<string, any>;
    language: string;
    cartButton: string;
}

var common = new CommonService();

class PageHeader extends Component<HeaderProps, HeaderState> {
    constructor(props: HeaderState) {
        super(props);
        let language = localStorage.getItem('language') || '';
        if (language === '') {
            language = 'en';
            localStorage.setItem('language', language);
        }
        this.state = {
            pageTitle: "",
            pageSlogen1: "",
            pageSlogen2: "",
            pageCartCounter: 0,
            pageTimer: 0,
            pageMenuItems: [],
            dictionary: [],
            language: language,
            cartButton: ''
        };
    }

    componentDidMount(): void {
        common.getLabels().then(translations => {
            localStorage.setItem('translations', JSON.stringify(translations));

            common.getHeaderMenu().then(menuItems => {
                let mappedMenu = menuItems.map((item: any) => ({ label: item.box_subtitle, link: item.box_slug }));
                mappedMenu.unshift({ label: 'Home', link: '/' });
                this.setState({
                    pageTitle: translations.filter((item: any) => item.setting_name === 'SITENAME')[0].setting_value_text || "Open Webshop",
                    pageSlogen1: translations.filter((item: any) => item.setting_name === 'SLOGEN')[0].setting_value_text || "Reggel városnézés, délután Duna, este gyertyafény a hullámokon.",
                    pageSlogen2: translations.filter((item: any) => item.setting_name === 'SLOGEN2')[0].setting_value_text || "Riverride, sétahajó, Hop-on Hop-off és Dinner & Cruise – egy helyen, rugalmasan.",
                    pageTimer: 0,
                    pageMenuItems: mappedMenu,
                    dictionary: translations,
                    cartButton: translations.filter((item: any) => item.setting_name === 'KOSAR')[0].setting_value_text || "Cart"
                });    
            });
        });
        this.getCartCount();
        signalDispatcher.on('addToCart', (newCart: Cart) => {
            let currentCount = 0;
            if (newCart) {
                newCart.tickets?.forEach(ticket => {
                    currentCount += ticket.quantity;
                });
                newCart.events?.forEach(event => {
                    currentCount += event.quantity;
                });
            }
            this.setState({ pageCartCounter: currentCount });
        });
        signalDispatcher.on('updateCartTicket', (updatedTickets: Array<any>) => {
            const uuid = localStorage.getItem('uuid');
            if (!uuid || uuid === '' || uuid === undefined) {
                common.getUID().then((uid: any) => {
                    if (uid && uid.uuid) {
                        localStorage.setItem('uuid', uid.uuid);
                    }
                    else {
                        localStorage.setItem('uuid', '');
                    }
                });
            }
        });
        signalDispatcher.on('updateCartEvent', (updatedEvents: Array<any>) => {
            const uuid = localStorage.getItem('uuid');
            if (!uuid || uuid === '' || uuid === undefined) {
                common.getUID().then((uid: any) => {
                    if (uid && uid.uuid) {
                        localStorage.setItem('uuid', uid.uuid);
                    }
                    else {
                        localStorage.setItem('uuid', '');
                    }
                });
            }
        });

        signalDispatcher.on('refreshCartCount', (cartCount: any) => {
            this.setState({ pageCartCounter: cartCount });
        });
    }

    componentWillUnmount(): void {
        signalDispatcher.off('addToCart', () => {});
        signalDispatcher.off('updateCartTicket', () => {});
        signalDispatcher.off('updateCartEvent', () => {});
        signalDispatcher.off('refreshCartCount', () => {});
    }

    private getCartCount(): void {
        let cartData = localStorage.getItem('cart');
        let currentCount = 0;
        if (cartData) {
            const cart = JSON.parse(cartData) as Cart;
            if (cart) {
                cart.tickets?.forEach(ticket => {
                    currentCount += ticket.quantity;
                });
                cart.events?.forEach(event => {
                    currentCount += event.quantity;
                });
            }
        }
        this.setState({ pageCartCounter: currentCount });
    }

    private navigatePage(url: string) {
        window.location.href = url;
    }

    private logout() {
        if (window.confirm(
            this.state.dictionary?.find((item: any) => item.setting_name === 'LOGOUT_CONFIRM')?.setting_value_text || 'Are you sure you want to log out?'
        )) {
            localStorage.removeItem('username');
            localStorage.removeItem('hotel');
            this.navigatePage('/');
        }
    }

    setLanguage(lang: string) {
        localStorage.setItem('language', lang);
        common.getLabels().then(translations => {
            localStorage.setItem('translations', JSON.stringify(translations));

            common.getHeaderMenu().then(menuItems => {
                let mappedMenu = menuItems.map((item: any) => ({ label: item.box_subtitle, link: item.box_slug }));
                mappedMenu.unshift({ label: 'Home', link: '/' });
                this.setState({
                    pageTitle: translations.filter((item: any) => item.setting_name === 'SITENAME')[0].setting_value_text || "Open Webshop",
                    pageSlogen1: translations.filter((item: any) => item.setting_name === 'SLOGEN')[0].setting_value_text || "Reggel városnézés, délután Duna, este gyertyafény a hullámokon.",
                    pageSlogen2: translations.filter((item: any) => item.setting_name === 'SLOGEN2')[0].setting_value_text || "Riverride, sétahajó, Hop-on Hop-off és Dinner & Cruise – egy helyen, rugalmasan.",
                    pageTimer: 0,
                    pageMenuItems: mappedMenu,
                    dictionary: translations,
                    cartButton: translations.filter((item: any) => item.setting_name === 'KOSAR')[0].setting_value_text || "Cart"
                });    
            });

            window.location.reload();
        });
    }

    render() {
        const currentPath = window.location.pathname;

        return (
            <Container fluid className="p-3 bg-danger text-white text-center oc-header">
                <Row>
                    <Col lg={5} md={6} sm={6} xs={6}>
                        <h1 className="oc-title">{this.state.pageTitle}</h1>
                    </Col>
                    <Col lg={4} md={4} sm={6} xs={6}>
                        <p className="oc-slogen">"{this.state.pageSlogen1}</p>
                        <p className="oc-slogen">{this.state.pageSlogen2}"</p>
                    </Col>
                    <Col lg={3} md={2} sm={12} xs={12} className="text-end">
                        <div className="cart-on-desktop">
                            <Button className="oc-cart-button" onClick={() => this.navigatePage('/cart')}>
                                <FontAwesomeIcon icon={faCartShopping}></FontAwesomeIcon> <small>{this.state.cartButton}</small>
                                <Badge className="oc-cart-badge">{this.state.pageCartCounter}</Badge>
                            </Button>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={10} md={10} sm={10} xs={10}>
                        <Navbar bg="red" expand="lg">
                            <Stack direction="horizontal" gap={5}>
                                <Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-navbar-toggle" />
                                <Navbar.Collapse id="basic-navbar-nav">
                                    <Nav className="me-auto">
                                        {this.state.pageMenuItems.map((item, index) => (
                                            <Button key={index} className={`oc-menu-button ${currentPath === item.link ? "active" : ""}`} onClick={() => this.navigatePage(item?.link)}>{item?.label}</Button>
                                        ))}
                                        <TimerBox></TimerBox>
                                    </Nav>
                                </Navbar.Collapse>
                            </Stack>
                        </Navbar>
                    </Col>
                    <Col lg={2} md={2} sm={2} xs={2} className="text-end valign-middle tool-buttons">
                        { localStorage.getItem('username') ? 
                        <a key={'logout'} className={`oc-lang-button`} onClick={() => this.logout()}>{localStorage.getItem('username')}</a>
                        : 
                        <a key={'login'} className={`oc-lang-button`} onClick={() => this.navigatePage('/login')}>Login</a>
                        }
                        <a key={'langswitch_en'} className={`oc-lang-button ${this.state.language === 'en' ? "active" : ""}`} onClick={() => this.setLanguage('en')}>EN</a>
                        <a key={'langswitch_hu'} className={`oc-lang-button ${this.state.language === 'hu' ? "active" : ""}`} onClick={() => this.setLanguage('hu')}>HU</a>
                    </Col>
                </Row>
                <div className="sticky-on-mobile">
                    <Button className="oc-cart-button" onClick={() => this.navigatePage('/cart')}>
                        <FontAwesomeIcon icon={faCartShopping}></FontAwesomeIcon> <small>{this.state.cartButton}</small>
                        <Badge className="oc-cart-badge">{this.state.pageCartCounter}</Badge>
                    </Button>
                </div>
            </Container>
        );
    }
}

export default PageHeader;